



























































































































































































































































import {
  computed,
  defineComponent,
  PropType,
  ref,
  nextTick,
  onMounted
} from "@vue/composition-api";
import { ApiResponse } from "@/api/types";
import EmptyView from "@/components/Atoms/EmptyView/index.vue";
import InputFieldGroup from "@/components/Organisms/InputFieldGroup/index.vue";
import InputField from "@/components/Organisms/InputField/index.vue";
import FieldAddButton from "@/components/Atoms/Forms/FieldAddButton/index.vue";
import OccHeading from "@/components/Atoms/OccHeading/index.vue";
import OccButton from "@/components/Atoms/OccButton/index.vue";
import OccHelp from "@/components/Atoms/OccHelp/index.vue";
import TextField from "@/components/Atoms/Forms/TextField/index.vue";
import TextArea from "@/components/Atoms/Forms/TextArea/index.vue";
import OccSelectbox from "@/components/Atoms/OccSelectbox/index.vue";
import { SelectItem } from "@/components/Atoms/OccSelectbox/types";

import OccToggleCheckbox from "@/components/Atoms/OccToggleCheckbox/index.vue";
import { AVAILABLE_IWEB_GRADUATE_YEARS } from "@/constants/i-web";

import { IwebType, JobEventReceptionType } from "@/api/types";
import { formConfig, eventCategorySelectList } from "@/helpers/jobEvent";
import { JOB_EVENT_STORE_KEY } from "@/helpers/hooks/useJobEvent";
import { useGlobalState } from "@/helpers/hooks/useGlobalState";
import { useComponentInstance } from "@/helpers/hooks/useComponentInstance";
import {
  checkEventApproved,
  getContractInfoAndStatusById
} from "@/helpers/contract-helper";
import { isDateBeforeCurrentDate } from "@/helpers/date-helper";
import { EditingJobEventScheduleType } from "../../../../../api/types";

export default defineComponent({
  components: {
    EmptyView,
    InputFieldGroup,
    InputField,
    FieldAddButton,
    OccHeading,
    OccButton,
    OccHelp,
    TextField,
    TextArea,
    OccSelectbox,
    OccToggleCheckbox
  },
  name: "PublishingForm",
  props: {
    contracts: {
      type: Array as PropType<ApiResponse.ContractInformation[]>,
      default: () => []
    }
  },
  setup(props) {
    const {
      editingJobEvent,
      jobEventErrors,
      disabledEdit,
      disabledReceptionTypeEdit,
      isShowIWebSetting,
      hasOnlineSchedule,
      setEditingJobEvent,
      getJobEventErrorMessage,
      setJobEventErrors,
      getJobEventWarningMessage,
      jobEventValidate
    } = useGlobalState(JOB_EVENT_STORE_KEY);

    onMounted(() => {
      // 契約が失効してイベントが非公開になっているかどうかのエラー文は初期段階で表示したい。
      // そのため、契約の有効性に関するバリデーションは画面立ち上がり段階で発火させる。
      if (
        editingJobEvent &&
        editingJobEvent.value &&
        editingJobEvent.value.contract_id
      ) {
        setEditingJobEvent(
          {
            ...editingJobEvent.value,
            contract_id: editingJobEvent.value?.contract_id
          },
          { key: "contract_id", subKey: "verifyContract" }
        );
        // contract_idから以前選択していた契約の詳細と有効かどうかを取得する。
        const result = getContractInfoAndStatusById(
          editingJobEvent?.value?.contract_id ?? 0
        );
        previouslySelectedContract.value = {
          data: result.data,
          isAvailable: result.isAvailable
        };
      }
    });

    // 契約終了によるイベント非公開のエラーメッセージは、プルダウン下には異なる形式で出力する。
    // そのため、ここではそのメッセージは除外する。代わりにこのvueファイルで別途レンダリングする。
    const contractErrorMessage = computed(() => {
      const errorMessage = getJobEventErrorMessage("contract_id");
      const excludedMessage =
        "対象契約の契約期間が終了したため、イベントが公開終了になっています。このイベントを公開したい場合は有効期間内の契約を選択してください。";
      return errorMessage === excludedMessage ? "" : errorMessage;
    });

    const hoveredItemId = ref<number>();

    const root = useComponentInstance();

    // props.contractsと型定義を合わせる。isAvailableは契約が有効かどうかを示す。
    const previouslySelectedContract = ref<{
      data: ApiResponse.ContractInformation | null;
      isAvailable: boolean;
    }>({
      data: null,
      isAvailable: false
    });

    const contractLabel = computed(() => {
      return `【${previouslySelectedContract.value.data?.graduate_year}年卒】${previouslySelectedContract.value.data?.plan}（${previouslySelectedContract.value.data?.period}）`;
    });

    const contractSelectList = computed(() => {
      // selectBoxの選択肢は契約ポリシーを保持していないため、storeから契約一覧を取り出す
      const partnerUser: ApiResponse.PartnerUser | undefined =
        root.$store.state.domains.user.partnerUser;
      const contracts = partnerUser?.partner.contracts || [];

      return props.contracts
        .filter(contractInfo => {
          const contract = contracts.find(
            contract => contract.id === contractInfo.id
          );
          if (!contract) {
            return false;
          }

          // mapする前に契約がイベント作成可能かチェックし、絞り込む
          return checkEventApproved(contract);
        })
        .map(v => {
          return {
            label: `【${v.graduate_year}年卒】${v.plan}（${v.period}）`,
            value: v.id
          };
        });
    });

    const iWebGraduateYearSelectList = computed<SelectItem[]>(() => {
      return AVAILABLE_IWEB_GRADUATE_YEARS.map(year => ({
        label: `${year}年`,
        value: String(year)
      }));
    });

    const iWebTypeSelectList = computed<SelectItem<IwebType>[]>(() => {
      return [
        { label: "インターン", value: "intern" },
        { label: "本選考", value: "entry" }
      ];
    });

    const disabledValues = computed(() => {
      const currentContract = previouslySelectedContract.value?.data;
      const isNotPublished =
        !editingJobEvent?.value?.publish_at ||
        !isDateBeforeCurrentDate(editingJobEvent?.value?.publish_at);

      // 現在の契約がない、もしくは未公開の場合は選択肢から除かない
      if (!currentContract || isNotPublished) {
        return [];
      }

      return props.contracts
        .filter(
          contract =>
            contract.graduate_year !== currentContract?.graduate_year &&
            contract.id !== currentContract?.id
        )
        .map(contract => contract.id);
    });

    const onChangeReceptionType = (value: JobEventReceptionType) => {
      if (!editingJobEvent.value) {
        return;
      }

      const updateSchedules = (scheduleType: EditingJobEventScheduleType) => {
        return editingJobEvent.value?.schedules.map(schedule => ({
          ...schedule,
          schedule_type: scheduleType
        }));
      };

      const schedules =
        value === "external"
          ? updateSchedules("offline") ?? []
          : updateSchedules("online") ?? [];

      setEditingJobEvent(
        {
          ...editingJobEvent.value,
          reception_type: value,
          schedules
        },
        { key: "reception_type" }
      );
      setJobEventErrors("application_url");
    };

    // 再レンダリングのトリガーとして使用
    const isRendered = ref(true);

    const handleChangeApplicationUrl = (value: string) => {
      if (!editingJobEvent.value) {
        return;
      }
      const trimmedValue = value.trim();
      setEditingJobEvent(
        {
          ...editingJobEvent.value,
          application_url: trimmedValue
        },
        { key: "application_url" }
      );

      if (value !== trimmedValue) {
        isRendered.value = false;
        nextTick(() => {
          isRendered.value = true;
        });
      }
    };

    return {
      formConfig,
      editingJobEvent,
      jobEventErrors,
      disabledEdit,
      disabledReceptionTypeEdit,
      disabledValues,
      setEditingJobEvent,
      getJobEventErrorMessage,
      setJobEventErrors,
      getJobEventWarningMessage,
      jobEventValidate,
      hoveredItemId,
      contractSelectList,
      previouslySelectedContract,
      contractLabel,
      contractErrorMessage,
      eventCategorySelectList,
      iWebGraduateYearSelectList,
      iWebTypeSelectList,
      isShowIWebSetting,
      hasOnlineSchedule,
      onChangeReceptionType,
      handleChangeApplicationUrl,
      isRendered
    };
  }
});
